export const GenderEnum = Object.freeze({
  MAN: "MAN",
  WOMAN: "WOMAN",
});
